import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {create} from "../../../app/setters/create.js";

export const useKlonujRaport = (prefix = 'oper') => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id) =>  create(`/${prefix}/raporty/klonuj`, {id}),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                queryKey: [`${prefix}_raporty`]
            })
        },
        onSuccess: ({message}) => {
            if (message) return  toast.success(message)
        },
        onError: ({message}) => {
            if (message) return  toast.error(message)
        }
    });
};
